export default "__VITE_ASSET__$Sgk96vS__"